import {motion} from "motion/react";
import {FiChevronDown} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";

interface AccordionHeaderIconProps {
  isActive: boolean;
  className?: string;
  iconInitialAngle?: number;
  iconActiveAngle?: number;
}

export const AccordionHeaderIcon = ({
  isActive,
  className,
  iconInitialAngle = 0,
  iconActiveAngle = 180,
}: AccordionHeaderIconProps) => (
  <motion.div
    className={className}
    initial={{rotate: isActive ? iconActiveAngle : iconInitialAngle}}
    animate={{rotate: isActive ? iconActiveAngle : iconInitialAngle}}
    transition={{
      type: "tween",
    }}
  >
    <Icon icon={FiChevronDown} />
  </motion.div>
);
